import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/config/site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, noindex = false, jsonLd = [] }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE.url}${pathname === "/" ? "/" : pathname}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE.url}${pathname === "/" ? "/" : pathname}`);

    document.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    const breadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE.url}/` },
        ...(pathname !== "/" ? [{ "@type": "ListItem", position: 2, name: title.split(" — ")[0].split(" | ")[0], item: `${SITE.url}${pathname}` }] : []),
      ],
    };
    [breadcrumb, ...jsonLd].forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, noindex, pathname, jsonLd]);
  return null;
};
